/**
 * Spanish (Latin American) Translations - Shared Translations shared between frontend and backend (single source of truth).
 */

import type { TranslationDictionaryType } from "../types/i18n.interface";
import type { AssertMatchingPlaceholders } from "../types/translation-key.types.js";

import type { en } from "./translations-en.constants";

export const es = {
  "shared.whatsapp.connectedMessage":
    "Hola {{otherName}}, soy {{userName}}. Conectamos en {{eventName}}. ¿Cuándo podemos charlar?",

  "invitations.openInvitation.defaultPhrase":
    "Hola Porter, soy parte de {{eventName}}",

  "shared.connectionCard.suggested": "Sugerido",
  "shared.connectionCard.wantsToMeet": "Quiere conocerte",
  "shared.connectionCard.nowConnected": "Ya conectados",
  "shared.profile.subtitle.withCompany": "{{position}} en {{company}}",

  "featureConfig.form.schemaForm.helperText.daysBeforeEventStart":
    "Dejar vacío para enriquecer apenas se agregan participantes.",
} as const satisfies TranslationDictionaryType;

// Compile-time assertion: Spanish must have same keys as English
export type AssertEsMatchesEnType = AssertMatchingPlaceholders<
  typeof en,
  typeof es
>;
